import React from 'react'
import { Input, ButtonSecondary } from '../../../components'
// import { useHistory } from 'react-router-dom';
// import { Link } from 'react-router-dom'

const apiUrl = 'https://bnpt-api.hubton.com/api/register'

// Example POST method implementation:
function postData(url = '', data = {}) {
  return new Promise(async (resolve, reject) => {
    // Default options are marked with *
    const response = await fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    });

    const json = await response.json()

    if (response.status === 200) {
      resolve(json)
    } else {
      reject(json)
    }
  })
}

const Form = ({className}) => {
  const [form, setForm] = React.useState({})
  const [errors, setErrors] = React.useState({})
  const [loading, setLoading] = React.useState(false)
  const [successMessage, setSuccessMessage] = React.useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)

    postData(apiUrl, form)
    .then(data => {
      setLoading(false)
      setSuccessMessage(data.message)
      setForm({})
      setErrors({})
    })
    .catch(err => {
      setLoading(false)
      setErrors(err)
    });
  }

  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  return (
    <form className={`${className}`}>
      { successMessage && (
        <div className="mb-3 bg-green-100 border-green-300 text-green-600 p-4 text-sm rounded">
          { successMessage }
        </div>
      ) }
      <div className="mb-3">
        <Input name="name" placeholder="Full Name" className="w-full" onChange={updateForm}/>
        {errors && 'name' in errors && (
          <div className="text-red-500 text-sm mt-1">{errors.name[0]}</div>
        )}
      </div>
      <div className="mb-3">
        <Input name="email" placeholder="Email" className="w-full" type="email" onChange={updateForm}/>
        {errors && 'email' in errors && (
          <div className="text-red-500 text-sm mt-1">{errors.email[0]}</div>
        )}
      </div>
      <div className="mb-3">
        <Input name="phone" placeholder="Phone" className="w-full" onChange={updateForm}/>
      </div>
      <div className="mb-5 lg:mb-8">
        <Input name="password" placeholder="Password" className="w-full" type="password" onChange={updateForm}/>
        {errors && 'password' in errors && (
          <div className="text-red-500 text-sm mt-1">{errors.password[0]}</div>
        )}
      </div>
      <ButtonSecondary onClick={handleSubmit} disabled={loading} className={`hidden lg:block ${loading ? 'opacity-25' : ''}`}>Register</ButtonSecondary>
      <ButtonSecondary onClick={handleSubmit} disabled={loading} className={`lg:hidden ${loading ? 'opacity-25' : ''}`} thin>Register</ButtonSecondary>
      {/* <Link to="/register-confirmation">
      </Link> */}
    </form>
  )
}

export { Form }
